<template>
  <CommonModal @onClose="onClose" :title="'Фильтр реестра наблюдений'">
    <template #body>
      <div :class="$style.container">
        <div :class="$style.content">
          <div :class="$style.body">
            <div :class="$style.field">
              <div :class="$style.title">Период наблюдения</div>
              <div :class="$style.input">
                <VueCtkDateTimePicker
                  v-model="date"
                  :only-date="true"
                  :range="true"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  input-size="sm"
                  label="Выберите период"
                  :no-button-now="true"
                  color="#000000"
                  :no-shortcuts="true"
                />
                <div v-if="date" :class="$style.close" @click="date = null">
                  <img src="/icons/common/cross-black.svg" alt="" />
                </div>
              </div>
            </div>
            <div :class="$style.select">
              <div :class="$style.title">Организация</div>
              <div :class="$style.input">
                <CommonSelectFilter
                  :openByClick="true"
                  placeholder="Организация"
                  :hints="organizations"
                  :value="
                    organizations.find((o) => o.slug === organization)?.title ||
                    organization
                  "
                  :disabled="false"
                  @setHint="(hint) => (organization = hint)"
                />
              </div>
            </div>

            <div :class="$style.select">
              <div :class="$style.title">Наблюдатель</div>
              <div :class="$style.input">
                <CommonSelectFilter
                  :openByClick="true"
                  placeholder="Наблюдатель"
                  :hints="users"
                  :value="users.find((u) => u.slug === user)?.title || user"
                  :disabled="false"
                  @setHint="(hint) => (user = hint)"
                />
              </div>
            </div>
            <div :class="$style.select">
              <div :class="$style.title">Работник</div>
              <div :class="$style.input">
                <CommonSelectFilter
                  :openByClick="true"
                  placeholder="Работник"
                  :hints="workers"
                  :value="
                    workers.find((w) => w.slug === worker)?.title || worker
                  "
                  :disabled="false"
                  @setHint="(hint) => (worker = hint)"
                />
              </div>
            </div>
            <div :class="$style.field">
              <div :class="$style.title">Id наблюдения</div>
              <div :class="$style.input">
                <input type="text" v-model="search" />
              </div>
            </div>
            <div :class="$style.checkboxGroup">
              <div
                :class="$style.checkbox"
                @click="verifiedChecked = !verifiedChecked"
              >
                <div :class="$style.checkboxIcon">
                  <img
                    v-if="verifiedChecked"
                    src="/icons/analytics/checkbox-gray-active.svg"
                    alt=""
                  />
                  <img v-else src="/icons/analytics/checkbox-gray.svg" alt="" />
                </div>
                <div :class="$style.checkboxLabel">Проверенные</div>
              </div>
              <div
                :class="$style.checkbox"
                @click="unverifiedChecked = !unverifiedChecked"
              >
                <div :class="$style.checkboxIcon">
                  <img
                    v-if="unverifiedChecked"
                    src="/icons/analytics/checkbox-gray-active.svg"
                    alt=""
                  />
                  <img v-else src="/icons/analytics/checkbox-gray.svg" alt="" />
                </div>
                <div :class="$style.checkboxLabel">Непроверенные</div>
              </div>
            </div>
            <div :class="$style.button" @click="setFilter">
              Применить фильтр
            </div>
          </div>
        </div>
      </div>
    </template>
  </CommonModal>
</template>

<script>
import Repository from "@/repository";
import CommonModal from "@/components/modals/CommonModal.vue";
import CommonSelectFilter from "@/components/common/CommonSelectFilter.vue";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

export default {
  components: {
    CommonModal,
    CommonSelectFilter,
    VueCtkDateTimePicker,
  },
  props: {
    params: Object,
  },
  data() {
    return {
      organization: "",
      worker: "",
      user: "",
      search: "",
      date: "",
      verified: false,
      verifiedChecked: false,
      unverifiedChecked: true,

      users: [],
      workers: [],
      organizations: [],
    };
  },
  mounted() {
    if (this.params) {
      this.organization = this.params.organization || "";
      this.worker = this.params.worker || "";
      this.user = this.params.user || "";
      this.search = this.params.search || "";
      this.date = this.params.date || "";
      const verifiedParam =
        this.params.verified !== undefined ? this.params.verified : false;
      if (verifiedParam === true) {
        this.verifiedChecked = true;
        this.unverifiedChecked = false;
      } else if (verifiedParam === false) {
        this.verifiedChecked = false;
        this.unverifiedChecked = true;
      } else {
        this.verifiedChecked = true;
        this.unverifiedChecked = true;
      }
    }
    this.fetchUsers();
    this.fetchWorkers();
    this.fetchOrganizations();
  },
  watch: {
    search(val) {
      if (val) {
        this.date = null;
        this.worker = "";
        this.user = "";
        this.organization = "";
      }
    },
    date(val) {
      if (val) this.search = "";
    },
    organization(val) {
      if (val) this.search = "";
    },
    worker(val) {
      if (val) this.search = "";
    },
    user(val) {
      if (val) this.search = "";
    },
  },
  methods: {
    async fetchUsers() {
      const { value } = await Repository.Users.get();
      if (value) {
        this.users = value.map((i) => ({ slug: i.id, title: i.username }));
      }
    },
    async fetchWorkers() {
      const { value } = await Repository.Users.get({ only_workers: true });
      if (value) {
        this.workers = value.map((i) => ({ slug: i.id, title: i.username }));
      }
    },
    async fetchOrganizations() {
      const { value } = await Repository.Organizations.get();
      if (value) {
        this.organizations = value.map((i) => ({
          slug: String(i.id),
          title: i.name,
        }));
      }
    },
    onClose() {
      this.$store.commit("setIconsModals", {
        modal: "filter",
        value: false,
      });
    },
    async setFilter() {
      let verified = null;
      if (this.verifiedChecked && !this.unverifiedChecked) {
        verified = true;
      } else if (!this.verifiedChecked && this.unverifiedChecked) {
        verified = false;
      }
      this.$emit("setFilter", {
        organization: this.organization,
        worker: this.worker,
        user: this.user,
        search: this.search,
        date: this.date,
        verified: verified,
      });
      this.$store.commit("setIconsModals", {
        modal: "filter",
        value: false,
      });
    },
  },
};
</script>

<style lang="scss" module>
.container {
  .content {
    margin-top: 1.5rem;
    .body {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;
      .field {
        // border: 1px solid $gray-34;
        // border-radius: 1rem;
        // display: flex;
        // flex-direction: column;
        // padding: 1rem;

        // margin: 0 0 1rem 0;
        &:last-child {
          margin: 0;
        }
        .title {
          font-weight: 700;
          flex: 0 0 18rem;
          margin-bottom: 0.75rem;
        }
        .input {
          width: 100%;
          background-color: $background;

          border-radius: 0.5rem;
          display: flex;
          align-items: center;

          padding: 1rem;
          input {
            width: 100%;
            outline: 0;
            border: none;
            font-size: 1rem;
            background-color: $background;
          }
          .close {
            cursor: pointer;
          }
        }
        :global {
          .date-time-picker {
            width: 100%;
            height: 100%;
            .field {
              min-height: auto !important;
            }
            .field-input {
              background-color: $background !important;
              border: none !important;
              padding: 0.125rem 0 !important;
              font-size: 1rem !important;
              min-height: auto !important;
              height: 100% !important;
              color: $black !important;
              &::placeholder {
                color: $black !important;
                font-family: "Manrope", sans-serif !important;
              }
            }
            .field-label {
              display: none !important;
            }
            .field-clear-button {
              display: none !important;
            }
          }
        }
      }
      .checkboxGroup {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
        .checkbox {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          cursor: pointer;
          .checkboxIcon {
            flex: 0 0 1.5rem;
            height: 1.5rem;
            img {
              width: 1.5rem;
              height: 1.5rem;
            }
          }
          .checkboxLabel {
            font-size: 1rem;
          }
        }
      }
      .button {
        border-radius: 0.5rem;
        color: $t-white;
        background-color: $black;
        padding: 0.75rem 2rem;
        width: 100%;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
</style>
